import script from "./DealList.vue?vue&type=script&setup=true&lang=js"
export * from "./DealList.vue?vue&type=script&setup=true&lang=js"

import "./DealList.vue?vue&type=style&index=0&id=7d0f653e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d0f653e"]])

export default __exports__